import styled, {css} from 'styled-components';

import {mixins} from '@edna/components/styles';
import BaseCloseIcon from '@edna/icons/close.svg';

import {BUTTON_BOTTOM_OFFSET, BUTTON_RIGHT_OFFSET, BUTTON_SIZE} from '../style';

export const Container = styled.div`
  ${mixins.stack({justify: 'stretch', align: 'stretch', size: '3'})}
  position: fixed;
  right: ${BUTTON_RIGHT_OFFSET}px;
  bottom: calc(${BUTTON_BOTTOM_OFFSET}px + ${BUTTON_SIZE}px + 10px);
  width: 376px;
  height: 600px;
  ${({theme}) => css`
    z-index: ${theme.zIndex.notifications};
    box-shadow: ${theme.boxShadow.XL};
    background-color: ${theme.color.white};
    padding: ${theme.spacing.s3};
    border-radius: ${theme.borderRadius.br2};
  `}
`;

export const Content = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.s5};
    padding-top: 0;
  `}

  ${mixins.stack({size: '4'})}
  flex-grow: 1;
`;

export const Header = styled.div`
  ${mixins.stack({
    direction: 'ROW',
    justify: 'space-between',
    align: 'center',
  })}

  ${({theme}) => css`
    padding: 0 ${theme.spacing.s5};
    border-bottom: 1px solid ${theme.palette.green400};
  `}

  height: 44px;
`;

export const CloseIcon = styled(BaseCloseIcon)`
  ${mixins.wh('20px')}
  flex-shrink: 0;
  cursor: pointer;
  color: ${({theme}) => theme.branding.content.tertiary};
`;
